export default __webpack_public_path__ + "static/media/group-582@3x.f00c70a0.png";